import { render, staticRenderFns } from "./PlacementCreate.vue?vue&type=template&id=114efb0c&scoped=true&"
import script from "./PlacementCreate.vue?vue&type=script&lang=js&"
export * from "./PlacementCreate.vue?vue&type=script&lang=js&"
import style0 from "./PlacementCreate.vue?vue&type=style&index=0&id=114efb0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114efb0c",
  null
  
)

export default component.exports